'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _htmlToReact = require('html-to-react');

var _htmlToReact2 = _interopRequireDefault(_htmlToReact);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _MPPHeading = require('../../../atoms/heading/jsx/MPPHeading');

var _MPPHeading2 = _interopRequireDefault(_MPPHeading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var htmlToReactParser = new _htmlToReact2.default.Parser();

var renderHeadline = function renderHeadline(headline) {
  if (headline) {
    return _react2.default.createElement(
      _MPPHeading2.default,
      {
        level: '2',
        className: 'features__headline col-xs-12 col-md-10 col-md-offset-1 text-xs-center'
      },
      htmlToReactParser.parse(headline.text)
    );
  }
  return null;
};

var renderFooter = function renderFooter(footer) {
  if (footer && footer.text) {
    return _react2.default.createElement(
      'div',
      { className: 'features__footer row' },
      _react2.default.createElement(
        'div',
        { className: 'col-xs-12' },
        _react2.default.createElement(
          'p',
          { className: 'text-xs-center legal-notes' },
          htmlToReactParser.parse(footer.text)
        )
      )
    );
  }
  return null;
};

var Features = function (_React$Component) {
  _inherits(Features, _React$Component);

  function Features(props) {
    _classCallCheck(this, Features);

    var _this = _possibleConstructorReturn(this, (Features.__proto__ || Object.getPrototypeOf(Features)).call(this, props));

    _this.columnClasses = {
      2: 'features__feature-container col-md-6 col-xs-12',
      3: 'features__feature-container col-md-4 col-xs-12'
    };
    _this.handleScroll = _this.handleScroll.bind(_this);
    _this.state = {
      showImages: false
    };
    // adding references in case this component is extended
    _this.renderHeadline = renderHeadline;
    _this.renderFooter = renderFooter;
    return _this;
  }

  _createClass(Features, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var domRect = this.sectionElement && this.sectionElement.getBoundingClientRect();
      if (domRect && window.innerHeight - domRect.top >= 0) {
        this.enableImages();
        return;
      }
      window.addEventListener('scroll', this.handleScroll);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.handleScroll);
    }
  }, {
    key: 'enableImages',
    value: function enableImages() {
      this.setState({
        showImages: true
      });
    }
  }, {
    key: 'handleScroll',
    value: function handleScroll() {
      window.removeEventListener('scroll', this.handleScroll);
      this.enableImages();
    }
  }, {
    key: 'renderFeatures',
    value: function renderFeatures(features, columns) {
      var _this2 = this;

      if (features) {
        // required when columns is sent as string
        var cols = parseInt(columns, 10);

        return _react2.default.createElement(
          'div',
          { className: 'row' },
          features.map(function (feature, idx) {
            var icon = feature.icon,
                headline = feature.headline;

            return _react2.default.createElement(
              'div',
              {
                key: idx,
                className: _this2.columnsClass,
                style: { clear: !(idx % cols) ? 'both' : null }
              },
              _react2.default.createElement(
                'div',
                { className: 'features__icon-container' },
                _react2.default.createElement('div', {
                  className: 'features__icon',
                  style: _this2.state.showImages && icon && icon.url ? { backgroundImage: 'url("' + icon.url + '")' } : null
                })
              ),
              _react2.default.createElement(
                _MPPHeading2.default,
                {
                  level: '3',
                  className: 'features__feature-headline pp-sans-small-regular h4 col-xs-10 col-sm-9 col-md-10'
                },
                htmlToReactParser.parse(headline.text)
              )
            );
          })
        );
      }
      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          content = _props.content,
          config = _props.config,
          className = _props.className;
      var headline = content.headline,
          features = content.features,
          footer = content.footer;
      var columns = config.columns,
          theme = config.theme,
          id = config.id;

      var featuresClasses = (0, _classnames2.default)('features', theme, className);

      return _react2.default.createElement(
        'section',
        { id: id, className: featuresClasses, 'data-building-block': 'organism' },
        _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement(
            'div',
            { className: 'row' },
            renderHeadline(headline)
          ),
          this.renderFeatures(features, columns),
          renderFooter(footer)
        )
      );
    }
  }, {
    key: 'columnsClass',
    get: function get() {
      var config = this.props.config && this.props.config.columns;
      return this.columnClasses[config] || this.columnClasses[2];
    }
  }]);

  return Features;
}(_react2.default.Component);

exports.default = Features;


Features.propTypes = {
  config: _propTypes2.default.shape({
    id: _propTypes2.default.string,
    columns: _propTypes2.default.oneOf([2, 3, '2', '3']).isRequired,
    theme: _propTypes2.default.oneOf(['theme-background-color-blue', 'theme-background-color-white', 'theme-background-color-light', 'theme-background-color-dark']).isRequired
  }),
  content: _propTypes2.default.shape({
    headline: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }).isRequired,
    features: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      headline: _propTypes2.default.shape({
        text: _propTypes2.default.string.isRequired
      }).isRequired,
      icon: _propTypes2.default.shape({
        url: _propTypes2.default.string.isRequired
      }).isRequired
    }).isRequired).isRequired,
    footer: _propTypes2.default.shape({
      text: _propTypes2.default.string
    })
  }),
  className: _propTypes2.default.string
};
/* eslint-disable max-len */
Features.defaultProps = {
  config: {
    id: '',
    theme: 'theme-background-color-dark',
    columns: 2
  },
  content: {
    headline: {
      text: '34 characters maximum'
    },
    features: [{
      icon: {
        url: 'https://www.paypalobjects.com/digitalassets/c/website/marketing/apac/C2/get-paid-on-marketplace/icon-walletbackward-white.png'
      },
      headline: {
        text: '45-80 characters maximum to optimize display on desktop or mobile'
      }
    }, {
      icon: {
        url: 'https://www.paypalobjects.com/digitalassets/c/website/marketing/apac/C2/get-paid-on-marketplace/simple-and-secure-icon.png'
      },
      headline: {
        text: '45-80 characters maximum to optimize display on desktop or mobile'
      }
    }, {
      icon: {
        url: 'https://www.paypalobjects.com/digitalassets/c/website/marketing/apac/C2/get-paid-on-marketplace/icon-cards-white.png'
      },
      headline: {
        text: '45-80 characters maximum to optimize display on desktop or mobile'
      }
    }, {
      icon: {
        url: 'https://www.paypalobjects.com/digitalassets/c/website/marketing/apac/C2/get-paid-on-marketplace/safer-icon.png'
      },
      headline: {
        text: '45-80 characters maximum to optimize display on desktop or mobile'
      }
    }, {
      icon: {
        url: 'https://www.paypalobjects.com/digitalassets/c/website/marketing/apac/C2/get-paid-on-marketplace/phone_white_icon.png'
      },
      headline: {
        text: '45-80 characters maximum to optimize display on desktop or mobile'
      }
    }, {
      icon: {
        url: 'https://www.paypalobjects.com/digitalassets/c/website/marketing/apac/C2/get-paid-on-marketplace/person_white_icon.png'
      },
      headline: {
        text: '45-80 characters maximum to optimize display on desktop or mobile'
      }
    }],
    footer: {
      text: 'Recommended maximum of 110 characters for paragraph text which equals ~3 lines of text in mobile portrait view.'
    }
  },
  className: ''
};
/* eslint-enable max-len */


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/features/jsx/Features.js
// module id = 1089
// module chunks = 4